<template>
    <v-content>
        <v-container fluid class="py-0 px-0">
            <v-row v-show="!acceso" transition="fade-transition">
                <v-col class="ma-5 pa-5">
                    <h1>Inicio de Sesión</h1>
                    <v-text-field label="Usuario" v-model="user" @keydown="error = false"
                                  @keydown.enter="checarAcceso"></v-text-field>
                    <v-text-field type="password" label="Contraseña" v-model="password" @keydown="error = false"
                                  @keydown.enter="checarAcceso"></v-text-field>
                    <v-btn @click="checarAcceso" :disabled="!!loading" dark>Ingresar</v-btn>

                    <v-alert type="warning" class="mt-5" v-show="error" key="0" transition="fade-transition">
                        Usuario o Contraseña Incorrecta
                    </v-alert>

                    <!--<p>Presentaciones</p>
                    <pre>
                        {{ presentacion }}
                    </pre>

                    <p>Usuario</p>
                    <pre>
                        {{ usuario }}
                    </pre>-->
                </v-col>
            </v-row>
            <v-row v-show="acceso" transition="fade-transition">
                <v-container v-if="acceso" class="py-0" fluid>
                    <v-row>
                        <v-col>
                            <p class="text-center subtituloPres mt-3 mb-0">{{ presentacion.fields.atencion }} / {{ presentacion.fields.cliente_nombre }}</p>
                            <h2 class="mt-0 mb-3 pb-3 text-center tituloPres">{{ presentacion.fields.nombre }}</h2>
                        </v-col>
                    </v-row>
                    <v-row v-if="!presentacion.fields.sinCondensados || !presentacion.fields.sinCotizacion">
                        <v-col class="text-center">
                            <v-btn-toggle v-model="opcion">
                                <v-btn :value="0">
                                    Propuestas
                                </v-btn>
                                <v-btn :value="1" v-if="!presentacion.fields.sinCondensados">
                                    Condensados
                                </v-btn>
                                <v-btn :value="2" v-if="!presentacion.fields.sinCotizacion">
                                    Cotizaciones
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <Divider/>
                            <Divider up="true"/>
                        </v-col>
                    </v-row>
                    <v-row v-if="opcion === 0">
                        <v-col class="py-0">
                            <Presentacion
                                :id="base"
                                :titulo="titulo"
                                :cliente="cliente"
                                :vendedores="vendedores"
                                :id-vendedor="idVendedor"
                                :logo="logo"
                                :eslogan-presentacion="eslogan"
                                :descripcion="descripcion"
                                :atencion="atencion"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="opcion === 1">
                        <v-col class="py-0">
                            <Detalle />
                        </v-col>
                    </v-row>
                    <v-row v-if="opcion === 2">
                        <v-col class="py-0">
                            <Lista />
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
import Vue from 'vue';
import Divider from "@/components/Divider";
import Presentacion from "../components/Presentacion";
import Detalle from "@/components/Detalle";
import {mapState, mapActions} from 'vuex'
import Lista from "@/components/Lista";

export default {
    components: {
        Lista,
        Presentacion, Detalle, Divider
    },
    data() {
        return {
            opcion: 0,
            cargado: false,
            acceso: false,
            error: false,
            user: '',
            password: '',
            base: '',
            titulo: '',
            vendedores: [],
            idVendedor: '',
            cliente: '',
            logo: '',
            eslogan: '',
            descripcion: '',
            atencion: '',
            nomenclatura: '',
        }
    },
    computed: {
        ...mapState(["usuario", "presentacion", "loading"]),
    },
    methods: {
        ...mapActions([
            "obtenerUsuario",
            "obtenerPresentacion",
            "registrarVisualizacion",
            "obtenerCotizaciones",
            "obtenerTiposProyectos",
            "obtenerProyectos",
            "obtenerConceptos",
            "obtenerTiposProductos",
            "obtenerProductos",
            "obtenerCondiciones",
        ]),
        checarAcceso() {
            this.obtenerUsuario({user: this.user, password: this.password}).then(() => {
                if (this.usuario.id && this.presentacion.id) {
                    console.log(!!this.presentacion.fields.precios);
                    Vue.set(this, 'mostrarPrecio', !!this.presentacion.fields.precios);
                    this.mostrarPrecio = !!this.presentacion.fields.precios;
                    this.registrarVisualizacion(this.usuario);
                    this.obtenerCotizaciones().then(() => console.log("Cotizaciones listas"));
                    this.obtenerTiposProyectos();
                    this.obtenerProyectos();
                    this.obtenerTiposProductos();
                    this.obtenerProductos();
                    this.obtenerCondiciones();
                    this.obtenerConceptos().then(() => {
                      this.acceso = true;
                    });
                } else {
                    this.error = true;
                }
            }).catch((error) => {
                console.error(error);
            });
        },
    },
    mounted() {
        this.obtenerPresentacion().then(() => {
            // this.checarAcceso();
        });
    }
}
</script>

<style>
</style>
